import { nanoid } from "nanoid";
import { Link } from "react-router-dom";

export const sectionTitle = (header, body) => {
  return (
    <div className="youth-programs-header">
      <h1>{header}</h1>
      <p>{body}</p>
    </div>
  );
};

const avatar = (
  <i
    className="ri-account-circle-line"
    style={{ color: "black", fontSize: "54px" }}
  ></i>
);

export const storiesData = [
  {
    avatar,
    id: nanoid(),
    name: "Amina Okonkwo",
    location: "Lagos, Nigeria",
    quote:
      '"AFRIYOFA transformed my life. The training and support I received helped me start my own vegetable farm. Now I employ five other young people from my community."',
    achievement: "Jobs Created",
    achievementCount: "5",
  },
  {
    avatar,
    id: nanoid(),
    name: "David Musoke",
    location: "Kampala, Uganda",
    quote:
      '"The technology training opened my eyes to modern farming. I now use mobile apps to track my crops and connect with buyers directly. My income has tripled!"',
    achievement: "Income Increase",
    achievementCount: "300%",
  },
  {
    avatar,
    id: nanoid(),
    name: "Grace Mensah",
    location: "Accra, Ghana",
    quote:
      '"Being part of the AFRIYOFA community gave me confidence and connections. Together with other young farmers, we formed a cooperative that serves over 200 families."',
    achievement: "Families Served",
    achievementCount: "200+",
  },
];

export const articles = (data) => {
  return data.map((article) => (
    <article key={article?.id}>
      <div>
        {article?.image && <img src={article.image} alt={article.title} />}
        {article?.category && <span>{article?.category}</span>}
      </div>
      <div>
        <div>
          {article?.date && <span>{article.date}</span>}
          {article?.date && <span> . </span>}
          {article?.readTime && <span>{article.readTime}</span>}
        </div>

        {article?.title && <h3>{article.title}</h3>}

        {article?.description && <p>{article.description}</p>}
      </div>
    </article>
  ));
};

//loader for fetching articles
export const articlesLoader = async () => {
  try {
    const api = process.env.REACT_APP_API_URL;
    const res = await fetch(`${api}/blog`, { credentials: "include" });
    if (res.status !== 200) {
      return []
    }
    const data = await res.json();
    return data;
  } catch (error) {
    return [];
  }
};

///contacts loading...
export const contactsLoader = async () => {
  try {
    const api = process.env.REACT_APP_API_URL;
    const res = await fetch(`${api}/contact/info`, { credentials: "include" });
    if (res.status !== 200) {
      return [];
    }
    const data = await res.json();
    return data;
  } catch (error) {
    return [];
  }
};

// next blue big button

export const Btn = ({ title, iconic, pathway, id, handleClick }) => {
  const onBtnClick = handleClick ? handleClick : () => {};

  return (
    <div className="home-btn">
      <Link to={pathway}>
        <button className="view-all-button" onClick={onBtnClick} id={id}>
          {title} {iconic && iconic}
        </button>
      </Link>
    </div>
  );
};
